import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CheckDuplicateProductObjectCodeQuery,
  GenerateProductObjectCodeQuery,
  ProductObjectApi,
} from 'api';

export const findProductObject = createAsyncThunk(
  'ProductObject/findProductObject',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ProductObjectApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findProductObjectWithEntityForTableList = createAsyncThunk(
  'ProductObject/findProductObjectWithEntityForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ProductObjectApi.findWithEntity(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createProductObject = createAsyncThunk(
  'ProductObject/createProductObject',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ProductObjectApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createImportProductObject = createAsyncThunk(
  'ProductObject/createImportProductObject',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await ProductObjectApi.createImport(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneProductObject = createAsyncThunk(
  'ProductObject/findOneProductObject',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await ProductObjectApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateProductObject = createAsyncThunk(
  'ProductObject/updateProductObject',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await ProductObjectApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeProductObject = createAsyncThunk(
  'productObject/removeProductObject',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await ProductObjectApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateProductObjectCode = createAsyncThunk(
  'productObject/checkDuplicateProductObjectCode',
  async (query: CheckDuplicateProductObjectCodeQuery, { rejectWithValue }) => {
    try {
      const response = await ProductObjectApi.checkDuplicate(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateProductObjectCode = createAsyncThunk(
  'productObject/generateProductObjectCode',
  async (query: GenerateProductObjectCodeQuery, { rejectWithValue }) => {
    try {
      const response = await ProductObjectApi.generateCode(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const productObjectSlice = createSlice({
  name: 'ProductObject',
  initialState,
  reducers: {
    reloadProductObject(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationProductObject(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListProductObject(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      findProductObjectWithEntityForTableList.fulfilled,
      (state, action) => {
        const { data } = action.payload;

        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            infoBox: {
              name: item.name,
              img: item.avatar,
            },
          };
        });

        state.tableList = newData;
      }
    );
  },
});

const { actions, reducer: productObjectReducer } = productObjectSlice;

export const {
  reloadProductObject,
  updateSavedPaginationProductObject,
  updateSavedListProductObject,
} = actions;

export default productObjectReducer;
